import React from 'react'

const TermsCondition = () => {
  return (
    <div>Terms&Condition</div>
  )
}

export default TermsCondition